import _toConsumableArray from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"],
    _excluded2 = ["name"],
    _excluded3 = ["control", "onSubmit", "children", "action", "method", "headers", "encType", "onError", "render", "onSuccess", "validateStatus"],
    _excluded4 = ["_f"],
    _excluded5 = ["_f"];
import _regeneratorRuntime from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';

var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};

var isDateObject = function isDateObject(value) {
  return value instanceof Date;
};

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};

var isObjectType = function isObjectType(value) {
  return typeof value === 'object';
};

var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
};

var getEventValue = function getEventValue(event) {
  return isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
};

var getNodeParentName = function getNodeParentName(name) {
  return name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
};

var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return names.has(getNodeParentName(name));
};

var isPlainObject = function isPlainObject(tempObject) {
  var prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};

var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';

function cloneObject(data) {
  var copy;
  var isArray = Array.isArray(data);

  if (data instanceof Date) {
    copy = new Date(data);
  } else if (data instanceof Set) {
    copy = new Set(data);
  } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
    copy = isArray ? [] : {};

    if (!isArray && !isPlainObject(data)) {
      copy = data;
    } else {
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }

  return copy;
}

var compact = function compact(value) {
  return Array.isArray(value) ? value.filter(Boolean) : [];
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

var _get = function get(obj, path, defaultValue) {
  if (!path || !isObject(obj)) {
    return defaultValue;
  }

  var result = compact(path.split(/[,[\].]+?/)).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var EVENTS = {
  BLUR: 'blur',
  FOCUS_OUT: 'focusout',
  CHANGE: 'change'
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
var HookFormContext = React.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */

var useFormContext = function useFormContext() {
  return React.useContext(HookFormContext);
};
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */


var FormProvider = function FormProvider(props) {
  var children = props.children,
      data = _objectWithoutProperties(props, _excluded);

  return React.createElement(HookFormContext.Provider, {
    value: data
  }, children);
};

var getProxyFormState = function getProxyFormState(formState, control, localProxyFormState) {
  var isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var result = {
    defaultValues: control._defaultValues
  };

  var _loop = function _loop(key) {
    Object.defineProperty(result, key, {
      get: function get() {
        var _key = key;

        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }

        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  };

  for (var key in formState) {
    _loop(key);
  }

  return result;
};

var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && !Object.keys(value).length;
};

var shouldRenderFormState = function shouldRenderFormState(formStateData, _proxyFormState, updateFormState, isRoot) {
  updateFormState(formStateData);

  var name = formStateData.name,
      formState = _objectWithoutProperties(formStateData, _excluded2);

  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(function (key) {
    return _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all);
  });
};

var convertToArrayPayload = function convertToArrayPayload(value) {
  return Array.isArray(value) ? value : [value];
};

var shouldSubscribeByName = function shouldSubscribeByName(name, signalName, exact) {
  return exact && signalName ? name === signalName : !name || !signalName || name === signalName || convertToArrayPayload(name).some(function (currentName) {
    return currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName));
  });
};

function useSubscribe(props) {
  var _props = React.useRef(props);

  _props.current = props;
  React.useEffect(function () {
    var subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
      next: _props.current.next
    });

    return function () {
      subscription && subscription.unsubscribe();
    };
  }, [props.disabled]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */


function useFormState(props) {
  var methods = useFormContext();

  var _ref = props || {},
      _ref$control = _ref.control,
      control = _ref$control === void 0 ? methods.control : _ref$control,
      disabled = _ref.disabled,
      name = _ref.name,
      exact = _ref.exact;

  var _React$useState = React.useState(control._formState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      formState = _React$useState2[0],
      updateFormState = _React$useState2[1];

  var _mounted = React.useRef(true);

  var _localProxyFormState = React.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });

  var _name = React.useRef(name);

  _name.current = name;
  useSubscribe({
    disabled: disabled,
    next: function next(value) {
      return _mounted.current && shouldSubscribeByName(_name.current, value.name, exact) && shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) && updateFormState(_objectSpread(_objectSpread({}, control._formState), value));
    },
    subject: control._subjects.state
  });
  React.useEffect(function () {
    _mounted.current = true;
    _localProxyFormState.current.isValid && control._updateValid(true);
    return function () {
      _mounted.current = false;
    };
  }, [control]);
  return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = function isString(value) {
  return typeof value === 'string';
};

var generateWatchOutput = function generateWatchOutput(names, _names, formValues, isGlobal, defaultValue) {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return _get(formValues, names, defaultValue);
  }

  if (Array.isArray(names)) {
    return names.map(function (fieldName) {
      return isGlobal && _names.watch.add(fieldName), _get(formValues, fieldName);
    });
  }

  isGlobal && (_names.watchAll = true);
  return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */


function useWatch(props) {
  var methods = useFormContext();

  var _ref2 = props || {},
      _ref2$control = _ref2.control,
      control = _ref2$control === void 0 ? methods.control : _ref2$control,
      name = _ref2.name,
      defaultValue = _ref2.defaultValue,
      disabled = _ref2.disabled,
      exact = _ref2.exact;

  var _name = React.useRef(name);

  _name.current = name;
  useSubscribe({
    disabled: disabled,
    subject: control._subjects.values,
    next: function next(formState) {
      if (shouldSubscribeByName(_name.current, formState.name, exact)) {
        updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
      }
    }
  });

  var _React$useState3 = React.useState(control._getWatch(name, defaultValue)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      value = _React$useState4[0],
      updateValue = _React$useState4[1];

  React.useEffect(function () {
    return control._removeUnmounted();
  });
  return value;
}

var isKey = function isKey(value) {
  return /^\w*$/.test(value);
};

var stringToPath = function stringToPath(input) {
  return compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
};

function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */


function useController(props) {
  var methods = useFormContext();
  var name = props.name,
      _props$control = props.control,
      control = _props$control === void 0 ? methods.control : _props$control,
      shouldUnregister = props.shouldUnregister;
  var isArrayField = isNameInFieldArray(control._names.array, name);
  var value = useWatch({
    control: control,
    name: name,
    defaultValue: _get(control._formValues, name, _get(control._defaultValues, name, props.defaultValue)),
    exact: true
  });
  var formState = useFormState({
    control: control,
    name: name
  });

  var _registerProps = React.useRef(control.register(name, _objectSpread(_objectSpread({}, props.rules), {}, {
    value: value
  })));

  _registerProps.current = control.register(name, props.rules);
  React.useEffect(function () {
    var _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;

    var updateMounted = function updateMounted(name, value) {
      var field = _get(control._fields, name);

      if (field) {
        field._f.mount = value;
      }
    };

    updateMounted(name, true);

    if (_shouldUnregisterField) {
      var _value = cloneObject(_get(control._options.defaultValues, name));

      set(control._defaultValues, name, _value);

      if (isUndefined(_get(control._formValues, name))) {
        set(control._formValues, name, _value);
      }
    }

    return function () {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  return {
    field: {
      name: name,
      value: value,
      onChange: React.useCallback(function (event) {
        return _registerProps.current.onChange({
          target: {
            value: getEventValue(event),
            name: name
          },
          type: EVENTS.CHANGE
        });
      }, [name]),
      onBlur: React.useCallback(function () {
        return _registerProps.current.onBlur({
          target: {
            value: _get(control._formValues, name),
            name: name
          },
          type: EVENTS.BLUR
        });
      }, [name, control]),
      ref: function ref(elm) {
        var field = _get(control._fields, name);

        if (field && elm) {
          field._f.ref = {
            focus: function focus() {
              return elm.focus();
            },
            select: function select() {
              return elm.select();
            },
            setCustomValidity: function setCustomValidity(message) {
              return elm.setCustomValidity(message);
            },
            reportValidity: function reportValidity() {
              return elm.reportValidity();
            }
          };
        }
      }
    },
    formState: formState,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.errors, name);
        }
      },
      isDirty: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.dirtyFields, name);
        }
      },
      isTouched: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.touchedFields, name);
        }
      },
      error: {
        enumerable: true,
        get: function get() {
          return _get(formState.errors, name);
        }
      }
    })
  };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */


var Controller = function Controller(props) {
  return props.render(useController(props));
};

var POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */

function Form(props) {
  var methods = useFormContext();

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      mounted = _React$useState6[0],
      setMounted = _React$useState6[1];

  var _props$control2 = props.control,
      control = _props$control2 === void 0 ? methods.control : _props$control2,
      onSubmit = props.onSubmit,
      children = props.children,
      action = props.action,
      _props$method = props.method,
      method = _props$method === void 0 ? POST_REQUEST : _props$method,
      headers = props.headers,
      encType = props.encType,
      onError = props.onError,
      render = props.render,
      onSuccess = props.onSuccess,
      validateStatus = props.validateStatus,
      rest = _objectWithoutProperties(props, _excluded3);

  var submit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
      var hasError, type;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              hasError = false;
              type = '';
              _context2.next = 4;
              return control.handleSubmit( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
                  var formData, formDataJson, _iterator, _step, name, shouldStringifySubmissionData, response;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          formData = new FormData();
                          formDataJson = '';

                          try {
                            formDataJson = JSON.stringify(data);
                          } catch (_a) {}

                          _iterator = _createForOfIteratorHelper(control._names.mount);

                          try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                              name = _step.value;
                              formData.append(name, _get(data, name));
                            }
                          } catch (err) {
                            _iterator.e(err);
                          } finally {
                            _iterator.f();
                          }

                          if (onSubmit) {
                            onSubmit({
                              data: data,
                              event: event,
                              method: method,
                              formData: formData,
                              formDataJson: formDataJson
                            });
                          }

                          if (!action) {
                            _context.next = 19;
                            break;
                          }

                          _context.prev = 7;
                          shouldStringifySubmissionData = [headers && headers['Content-Type'], encType].some(function (value) {
                            return value && value.includes('json');
                          });
                          _context.next = 11;
                          return fetch(action, {
                            method: method,
                            headers: _objectSpread(_objectSpread({}, headers), encType ? {
                              'Content-Type': encType
                            } : {}),
                            body: shouldStringifySubmissionData ? formDataJson : formData
                          });

                        case 11:
                          response = _context.sent;

                          if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                            hasError = true;
                            onError && onError({
                              response: response
                            });
                            type = String(response.status);
                          } else {
                            onSuccess && onSuccess({
                              response: response
                            });
                          }

                          _context.next = 19;
                          break;

                        case 15:
                          _context.prev = 15;
                          _context.t0 = _context["catch"](7);
                          hasError = true;
                          onError && onError({
                            error: _context.t0
                          });

                        case 19:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[7, 15]]);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }())(event);

            case 4:
              if (hasError && props.control) {
                props.control._subjects.state.next({
                  isSubmitSuccessful: false
                });

                props.control.setError('root.server', {
                  type: type
                });
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function submit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    setMounted(true);
  }, []);
  return render ? React.createElement(React.Fragment, null, render({
    submit: submit
  })) : React.createElement("form", _objectSpread({
    noValidate: mounted,
    action: action,
    method: method,
    encType: encType,
    onSubmit: submit
  }, rest), children);
}

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  return validateAllFieldCriteria ? _objectSpread(_objectSpread({}, errors[name]), {}, {
    types: _objectSpread(_objectSpread({}, errors[name] && errors[name].types ? errors[name].types : {}), {}, _defineProperty({}, type, message || true))
  }) : {};
};

var focusFieldBy = function focusFieldBy(fields, callback, fieldsNames) {
  var _iterator2 = _createForOfIteratorHelper(fieldsNames || Object.keys(fields)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;

      var field = _get(fields, key);

      if (field) {
        var _f = field._f,
            currentField = _objectWithoutProperties(field, _excluded4);

        if (_f && callback(_f.name)) {
          if (_f.ref.focus) {
            _f.ref.focus();

            break;
          } else if (_f.refs && _f.refs[0].focus) {
            _f.refs[0].focus();

            break;
          }
        } else if (isObject(currentField)) {
          focusFieldBy(currentField, callback);
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

var generateId = function generateId() {
  var d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var getFocusFieldName = function getFocusFieldName(name, index) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || "".concat(name, ".").concat(isUndefined(options.focusIndex) ? index : options.focusIndex, ".") : '';
};

var getValidationModes = function getValidationModes(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  };
};

var isWatched = function isWatched(name, _names, isBlurEvent) {
  return !isBlurEvent && (_names.watchAll || _names.watch.has(name) || _toConsumableArray(_names.watch).some(function (watchName) {
    return name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length));
  }));
};

var updateFieldArrayRootError = function updateFieldArrayRootError(errors, error, name) {
  var fieldArrayErrors = compact(_get(errors, name));
  set(fieldArrayErrors, 'root', error[name]);
  set(errors, name, fieldArrayErrors);
  return errors;
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isHTMLElement = function isHTMLElement(value) {
  if (!isWeb) {
    return false;
  }

  var owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};

var isMessage = function isMessage(value) {
  return isString(value);
};

var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};

var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = function getCheckboxValue(options) {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.checked && !option.disabled;
      }).map(function (option) {
        return option.value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }

    return options[0].checked && !options[0].disabled ? // @ts-expect-error expected to work in the browser
    options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
      value: options[0].value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

var defaultReturn = {
  isValid: false,
  value: null
};

var getRadioValue = function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, option) {
    return option && option.checked && !option.disabled ? {
      isValid: true,
      value: option.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};

function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isMessage(result) ? result : '',
      ref: ref
    };
  }
}

var getValueAndMessage = function getValueAndMessage(validationData) {
  return isObject(validationData) && !isRegex(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};

var validateField = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
    var _field$_f, ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, inputValue, inputRef, setCustomValidity, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref6, value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, convertTimeToDate, isTime, isWeek, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message, result, validateError, validationResult, key, _validateError;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _field$_f = field._f, ref = _field$_f.ref, refs = _field$_f.refs, required = _field$_f.required, maxLength = _field$_f.maxLength, minLength = _field$_f.minLength, min = _field$_f.min, max = _field$_f.max, pattern = _field$_f.pattern, validate = _field$_f.validate, name = _field$_f.name, valueAsNumber = _field$_f.valueAsNumber, mount = _field$_f.mount, disabled = _field$_f.disabled;
            inputValue = _get(formValues, name);

            if (!(!mount || disabled)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", {});

          case 4:
            inputRef = refs ? refs[0] : ref;

            setCustomValidity = function setCustomValidity(message) {
              if (shouldUseNativeValidation && inputRef.reportValidity) {
                inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
                inputRef.reportValidity();
              }
            };

            error = {};
            isRadio = isRadioInput(ref);
            isCheckBox = isCheckBoxInput(ref);
            isRadioOrCheckbox = isRadio || isCheckBox;
            isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
            appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

            getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
              var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
              var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
              var message = exceedMax ? maxLengthMessage : minLengthMessage;
              error[name] = _objectSpread({
                type: exceedMax ? maxType : minType,
                message: message,
                ref: ref
              }, appendErrorsCurry(exceedMax ? maxType : minType, message));
            };

            if (!(isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid))) {
              _context3.next = 20;
              break;
            }

            _ref6 = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), value = _ref6.value, message = _ref6.message;

            if (!value) {
              _context3.next = 20;
              break;
            }

            error[name] = _objectSpread({
              type: INPUT_VALIDATION_RULES.required,
              message: message,
              ref: inputRef
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

            if (validateAllFieldCriteria) {
              _context3.next = 20;
              break;
            }

            setCustomValidity(message);
            return _context3.abrupt("return", error);

          case 20:
            if (!(!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max)))) {
              _context3.next = 29;
              break;
            }

            maxOutput = getValueAndMessage(max);
            minOutput = getValueAndMessage(min);

            if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
              valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);

              if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
              }

              if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(inputValue);

              convertTimeToDate = function convertTimeToDate(time) {
                return new Date(new Date().toDateString() + ' ' + time);
              };

              isTime = ref.type == 'time';
              isWeek = ref.type == 'week';

              if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
              }

              if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
              }
            }

            if (!(exceedMax || exceedMin)) {
              _context3.next = 29;
              break;
            }

            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

            if (validateAllFieldCriteria) {
              _context3.next = 29;
              break;
            }

            setCustomValidity(error[name].message);
            return _context3.abrupt("return", error);

          case 29:
            if (!((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue)))) {
              _context3.next = 39;
              break;
            }

            maxLengthOutput = getValueAndMessage(maxLength);
            minLengthOutput = getValueAndMessage(minLength);
            _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
            _exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;

            if (!(_exceedMax || _exceedMin)) {
              _context3.next = 39;
              break;
            }

            getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);

            if (validateAllFieldCriteria) {
              _context3.next = 39;
              break;
            }

            setCustomValidity(error[name].message);
            return _context3.abrupt("return", error);

          case 39:
            if (!(pattern && !isEmpty && isString(inputValue))) {
              _context3.next = 46;
              break;
            }

            _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message = _getValueAndMessage.message;

            if (!(isRegex(patternValue) && !inputValue.match(patternValue))) {
              _context3.next = 46;
              break;
            }

            error[name] = _objectSpread({
              type: INPUT_VALIDATION_RULES.pattern,
              message: _message,
              ref: ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message));

            if (validateAllFieldCriteria) {
              _context3.next = 46;
              break;
            }

            setCustomValidity(_message);
            return _context3.abrupt("return", error);

          case 46:
            if (!validate) {
              _context3.next = 80;
              break;
            }

            if (!isFunction(validate)) {
              _context3.next = 59;
              break;
            }

            _context3.next = 50;
            return validate(inputValue, formValues);

          case 50:
            result = _context3.sent;
            validateError = getValidateError(result, inputRef);

            if (!validateError) {
              _context3.next = 57;
              break;
            }

            error[name] = _objectSpread(_objectSpread({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (validateAllFieldCriteria) {
              _context3.next = 57;
              break;
            }

            setCustomValidity(validateError.message);
            return _context3.abrupt("return", error);

          case 57:
            _context3.next = 80;
            break;

          case 59:
            if (!isObject(validate)) {
              _context3.next = 80;
              break;
            }

            validationResult = {};
            _context3.t0 = _regeneratorRuntime.keys(validate);

          case 62:
            if ((_context3.t1 = _context3.t0()).done) {
              _context3.next = 76;
              break;
            }

            key = _context3.t1.value;

            if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
              _context3.next = 66;
              break;
            }

            return _context3.abrupt("break", 76);

          case 66:
            _context3.t2 = getValidateError;
            _context3.next = 69;
            return validate[key](inputValue, formValues);

          case 69:
            _context3.t3 = _context3.sent;
            _context3.t4 = inputRef;
            _context3.t5 = key;
            _validateError = (0, _context3.t2)(_context3.t3, _context3.t4, _context3.t5);

            if (_validateError) {
              validationResult = _objectSpread(_objectSpread({}, _validateError), appendErrorsCurry(key, _validateError.message));
              setCustomValidity(_validateError.message);

              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }

            _context3.next = 62;
            break;

          case 76:
            if (isEmptyObject(validationResult)) {
              _context3.next = 80;
              break;
            }

            error[name] = _objectSpread({
              ref: inputRef
            }, validationResult);

            if (validateAllFieldCriteria) {
              _context3.next = 80;
              break;
            }

            return _context3.abrupt("return", error);

          case 80:
            setCustomValidity(true);
            return _context3.abrupt("return", error);

          case 82:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function validateField(_x3, _x4, _x5, _x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

function append(data, value) {
  return [].concat(_toConsumableArray(data), _toConsumableArray(convertToArrayPayload(value)));
}

var fillEmptyArray = function fillEmptyArray(value) {
  return Array.isArray(value) ? value.map(function () {
    return undefined;
  }) : undefined;
};

function insert(data, index, value) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(convertToArrayPayload(value)), _toConsumableArray(data.slice(index)));
}

var moveArrayAt = function moveArrayAt(data, from, to) {
  if (!Array.isArray(data)) {
    return [];
  }

  if (isUndefined(data[to])) {
    data[to] = undefined;
  }

  data.splice(to, 0, data.splice(from, 1)[0]);
  return data;
};

function prepend(data, value) {
  return [].concat(_toConsumableArray(convertToArrayPayload(value)), _toConsumableArray(convertToArrayPayload(data)));
}

function removeAtIndexes(data, indexes) {
  var i = 0;

  var temp = _toConsumableArray(data);

  var _iterator3 = _createForOfIteratorHelper(indexes),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var index = _step3.value;
      temp.splice(index - i, 1);
      i++;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return compact(temp).length ? temp : [];
}

var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort(function (a, b) {
    return a - b;
  }));
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  data[indexA] = [data[indexB], data[indexB] = data[indexA]][0];
};

function baseGet(object, updatePath) {
  var length = updatePath.slice(0, -1).length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return object;
}

function isEmptyArray(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }

  return true;
}

function unset(object, path) {
  var paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath(path);
  var childObject = paths.length === 1 ? object : baseGet(object, paths);
  var index = paths.length - 1;
  var key = paths[index];

  if (childObject) {
    delete childObject[key];
  }

  if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }

  return object;
}

var updateAt = function updateAt(fieldValues, index, value) {
  fieldValues[index] = value;
  return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */


function useFieldArray(props) {
  var methods = useFormContext();
  var _props$control3 = props.control,
      control = _props$control3 === void 0 ? methods.control : _props$control3,
      name = props.name,
      _props$keyName = props.keyName,
      keyName = _props$keyName === void 0 ? 'id' : _props$keyName,
      shouldUnregister = props.shouldUnregister;

  var _React$useState7 = React.useState(control._getFieldArray(name)),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      fields = _React$useState8[0],
      setFields = _React$useState8[1];

  var ids = React.useRef(control._getFieldArray(name).map(generateId));

  var _fieldIds = React.useRef(fields);

  var _name = React.useRef(name);

  var _actioned = React.useRef(false);

  _name.current = name;
  _fieldIds.current = fields;

  control._names.array.add(name);

  props.rules && control.register(name, props.rules);
  useSubscribe({
    next: function next(_ref7) {
      var values = _ref7.values,
          fieldArrayName = _ref7.name;

      if (fieldArrayName === _name.current || !fieldArrayName) {
        var fieldValues = _get(values, _name.current);

        if (Array.isArray(fieldValues)) {
          setFields(fieldValues);
          ids.current = fieldValues.map(generateId);
        }
      }
    },
    subject: control._subjects.array
  });
  var updateValues = React.useCallback(function (updatedFieldArrayValues) {
    _actioned.current = true;

    control._updateFieldArray(name, updatedFieldArrayValues);
  }, [control, name]);

  var append$1 = function append$1(value, options) {
    var appendValue = convertToArrayPayload(cloneObject(value));
    var updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
    control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
    ids.current = append(ids.current, appendValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._updateFieldArray(name, updatedFieldArrayValues, append, {
      argA: fillEmptyArray(value)
    });
  };

  var prepend$1 = function prepend$1(value, options) {
    var prependValue = convertToArrayPayload(cloneObject(value));
    var updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
    control._names.focus = getFocusFieldName(name, 0, options);
    ids.current = prepend(ids.current, prependValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
      argA: fillEmptyArray(value)
    });
  };

  var remove = function remove(index) {
    var updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
    ids.current = removeArrayAt(ids.current, index);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
      argA: index
    });
  };

  var insert$1 = function insert$1(index, value, options) {
    var insertValue = convertToArrayPayload(cloneObject(value));
    var updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
    control._names.focus = getFocusFieldName(name, index, options);
    ids.current = insert(ids.current, index, insertValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._updateFieldArray(name, updatedFieldArrayValues, insert, {
      argA: index,
      argB: fillEmptyArray(value)
    });
  };

  var swap = function swap(indexA, indexB) {
    var updatedFieldArrayValues = control._getFieldArray(name);

    swapArrayAt(updatedFieldArrayValues, indexA, indexB);
    swapArrayAt(ids.current, indexA, indexB);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
      argA: indexA,
      argB: indexB
    }, false);
  };

  var move = function move(from, to) {
    var updatedFieldArrayValues = control._getFieldArray(name);

    moveArrayAt(updatedFieldArrayValues, from, to);
    moveArrayAt(ids.current, from, to);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
      argA: from,
      argB: to
    }, false);
  };

  var update = function update(index, value) {
    var updateValue = cloneObject(value);
    var updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
    ids.current = _toConsumableArray(updatedFieldArrayValues).map(function (item, i) {
      return !item || i === index ? generateId() : ids.current[i];
    });
    updateValues(updatedFieldArrayValues);
    setFields(_toConsumableArray(updatedFieldArrayValues));

    control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
      argA: index,
      argB: updateValue
    }, true, false);
  };

  var replace = function replace(value) {
    var updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
    ids.current = updatedFieldArrayValues.map(generateId);
    updateValues(_toConsumableArray(updatedFieldArrayValues));
    setFields(_toConsumableArray(updatedFieldArrayValues));

    control._updateFieldArray(name, _toConsumableArray(updatedFieldArrayValues), function (data) {
      return data;
    }, {}, true, false);
  };

  React.useEffect(function () {
    control._state.action = false;
    isWatched(name, control._names) && control._subjects.state.next(_objectSpread({}, control._formState));

    if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
      if (control._options.resolver) {
        control._executeSchema([name]).then(function (result) {
          var error = _get(result.errors, name);

          var existingError = _get(control._formState.errors, name);

          if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
            error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);

            control._subjects.state.next({
              errors: control._formState.errors
            });
          }
        });
      } else {
        var field = _get(control._fields, name);

        if (field && field._f) {
          validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then(function (error) {
            return !isEmptyObject(error) && control._subjects.state.next({
              errors: updateFieldArrayRootError(control._formState.errors, error, name)
            });
          });
        }
      }
    }

    control._subjects.values.next({
      name: name,
      values: _objectSpread({}, control._formValues)
    });

    control._names.focus && focusFieldBy(control._fields, function (key) {
      return !!key && key.startsWith(control._names.focus || '');
    });
    control._names.focus = '';

    control._updateValid();
  }, [fields, name, control]);
  React.useEffect(function () {
    !_get(control._formValues, name) && control._updateFieldArray(name);
    return function () {
      (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
    };
  }, [name, control, keyName, shouldUnregister]);
  return {
    swap: React.useCallback(swap, [updateValues, name, control]),
    move: React.useCallback(move, [updateValues, name, control]),
    prepend: React.useCallback(prepend$1, [updateValues, name, control]),
    append: React.useCallback(append$1, [updateValues, name, control]),
    remove: React.useCallback(remove, [updateValues, name, control]),
    insert: React.useCallback(insert$1, [updateValues, name, control]),
    update: React.useCallback(update, [updateValues, name, control]),
    replace: React.useCallback(replace, [updateValues, name, control]),
    fields: React.useMemo(function () {
      return fields.map(function (field, index) {
        return _objectSpread(_objectSpread({}, field), {}, _defineProperty({}, keyName, ids.current[index] || generateId()));
      });
    }, [fields, keyName])
  };
}

function createSubject() {
  var _observers = [];

  var next = function next(value) {
    var _iterator4 = _createForOfIteratorHelper(_observers),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var observer = _step4.value;
        observer.next && observer.next(value);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  };

  var subscribe = function subscribe(observer) {
    _observers.push(observer);

    return {
      unsubscribe: function unsubscribe() {
        _observers = _observers.filter(function (o) {
          return o !== observer;
        });
      }
    };
  };

  var unsubscribe = function unsubscribe() {
    _observers = [];
  };

  return {
    get observers() {
      return _observers;
    },

    next: next,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}

var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};

function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }

  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }

  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key];

    if (!keys2.includes(key)) {
      return false;
    }

    if (key !== 'ref') {
      var val2 = object2[key];

      if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }

  return true;
}

var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "select-multiple";
};

var isRadioOrCheckbox = function isRadioOrCheckbox(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};

var live = function live(ref) {
  return isHTMLElement(ref) && ref.isConnected;
};

var objectHasFunction = function objectHasFunction(data) {
  for (var key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }

  return false;
};

function markFieldsDirty(data) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isParentNodeArray = Array.isArray(data);

  if (isObject(data) || isParentNodeArray) {
    for (var key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }

  return fields;
}

function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  var isParentNodeArray = Array.isArray(data);

  if (isObject(data) || isParentNodeArray) {
    for (var key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : _objectSpread({}, markFieldsDirty(data[key]));
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }

  return dirtyFieldsFromValues;
}

var getDirtyFields = function getDirtyFields(defaultValues, formValues) {
  return getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
};

var getFieldValueAs = function getFieldValueAs(value, _ref8) {
  var valueAsNumber = _ref8.valueAsNumber,
      valueAsDate = _ref8.valueAsDate,
      setValueAs = _ref8.setValueAs;
  return isUndefined(value) ? value : valueAsNumber ? value === '' ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
};

function getFieldValue(_f) {
  var ref = _f.ref;

  if (_f.refs ? _f.refs.every(function (ref) {
    return ref.disabled;
  }) : ref.disabled) {
    return;
  }

  if (isFileInput(ref)) {
    return ref.files;
  }

  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }

  if (isMultipleSelect(ref)) {
    return _toConsumableArray(ref.selectedOptions).map(function (_ref9) {
      var value = _ref9.value;
      return value;
    });
  }

  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }

  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = function getResolverOptions(fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) {
  var fields = {};

  var _iterator5 = _createForOfIteratorHelper(fieldsNames),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _name2 = _step5.value;

      var field = _get(_fields, _name2);

      field && set(fields, _name2, field._f);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return {
    criteriaMode: criteriaMode,
    names: _toConsumableArray(fieldsNames),
    fields: fields,
    shouldUseNativeValidation: shouldUseNativeValidation
  };
};

var getRuleValue = function getRuleValue(rule) {
  return isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
};

var hasValidation = function hasValidation(options) {
  return options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
};

function schemaErrorLookup(errors, _fields, name) {
  var error = _get(errors, name);

  if (error || isKey(name)) {
    return {
      error: error,
      name: name
    };
  }

  var names = name.split('.');

  while (names.length) {
    var fieldName = names.join('.');

    var field = _get(_fields, fieldName);

    var foundError = _get(errors, fieldName);

    if (field && !Array.isArray(field) && name !== fieldName) {
      return {
        name: name
      };
    }

    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }

    names.pop();
  }

  return {
    name: name
  };
}

var skipValidation = function skipValidation(isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }

  return true;
};

var unsetEmptyArray = function unsetEmptyArray(ref, name) {
  return !compact(_get(ref, name)).length && unset(ref, name);
};

var defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};

function createFormControl() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var flushRootRender = arguments.length > 1 ? arguments[1] : undefined;

  var _options = _objectSpread(_objectSpread({}, defaultOptions), props);

  var _formState = {
    submitCount: 0,
    isDirty: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  };
  var _fields = {};

  var _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};

  var _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);

  var _state = {
    action: false,
    mount: false,
    watch: false
  };
  var _names = {
    mount: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  };
  var delayErrorCallback;
  var timer = 0;
  var _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  var _subjects = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  var shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
  var validationModeBeforeSubmit = getValidationModes(_options.mode);
  var validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  var shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;

  var debounce = function debounce(callback) {
    return function (wait) {
      clearTimeout(timer);
      timer = setTimeout(callback, wait);
    };
  };

  var _updateValid = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(shouldUpdateValid) {
      var isValid;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_proxyFormState.isValid || shouldUpdateValid)) {
                _context4.next = 14;
                break;
              }

              if (!_options.resolver) {
                _context4.next = 9;
                break;
              }

              _context4.t1 = isEmptyObject;
              _context4.next = 5;
              return _executeSchema();

            case 5:
              _context4.t2 = _context4.sent.errors;
              _context4.t0 = (0, _context4.t1)(_context4.t2);
              _context4.next = 12;
              break;

            case 9:
              _context4.next = 11;
              return executeBuiltInValidation(_fields, true);

            case 11:
              _context4.t0 = _context4.sent;

            case 12:
              isValid = _context4.t0;

              if (isValid !== _formState.isValid) {
                _subjects.state.next({
                  isValid: isValid
                });
              }

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function _updateValid(_x8) {
      return _ref10.apply(this, arguments);
    };
  }();

  var _updateIsValidating = function _updateIsValidating(value) {
    return _proxyFormState.isValidating && _subjects.state.next({
      isValidating: value
    });
  };

  var _updateFieldArray = function _updateFieldArray(name) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var method = arguments.length > 2 ? arguments[2] : undefined;
    var args = arguments.length > 3 ? arguments[3] : undefined;
    var shouldSetValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldUpdateFieldsAndState = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    if (args && method) {
      _state.action = true;

      if (shouldUpdateFieldsAndState && Array.isArray(_get(_fields, name))) {
        var fieldValues = method(_get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }

      if (shouldUpdateFieldsAndState && Array.isArray(_get(_formState.errors, name))) {
        var errors = method(_get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }

      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(_get(_formState.touchedFields, name))) {
        var touchedFields = method(_get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }

      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }

      _subjects.state.next({
        name: name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values);
    }
  };

  var updateErrors = function updateErrors(name, error) {
    set(_formState.errors, name, error);

    _subjects.state.next({
      errors: _formState.errors
    });
  };

  var updateValidAndValue = function updateValidAndValue(name, shouldSkipSetValueAs, value, ref) {
    var field = _get(_fields, name);

    if (field) {
      var defaultValue = _get(_formValues, name, isUndefined(value) ? _get(_defaultValues, name) : value);

      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _updateValid();
    }
  };

  var updateTouchAndDirty = function updateTouchAndDirty(name, fieldValue, isBlurEvent, shouldDirty, shouldRender) {
    var shouldUpdateField = false;
    var isPreviousDirty = false;
    var output = {
      name: name
    };

    if (!isBlurEvent || shouldDirty) {
      if (_proxyFormState.isDirty) {
        isPreviousDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        shouldUpdateField = isPreviousDirty !== output.isDirty;
      }

      var isCurrentFieldPristine = deepEqual(_get(_defaultValues, name), fieldValue);
      isPreviousDirty = _get(_formState.dirtyFields, name);
      isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
      output.dirtyFields = _formState.dirtyFields;
      shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
    }

    if (isBlurEvent) {
      var isPreviousFieldTouched = _get(_formState.touchedFields, name);

      if (!isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
    }

    shouldUpdateField && shouldRender && _subjects.state.next(output);
    return shouldUpdateField ? output : {};
  };

  var shouldRenderByError = function shouldRenderByError(name, isValid, error, fieldState) {
    var previousFieldError = _get(_formState.errors, name);

    var shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;

    if (props.delayError && error) {
      delayErrorCallback = debounce(function () {
        return updateErrors(name, error);
      });
      delayErrorCallback(props.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }

    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      var updatedFormState = _objectSpread(_objectSpread(_objectSpread({}, fieldState), shouldUpdateValid && isBoolean(isValid) ? {
        isValid: isValid
      } : {}), {}, {
        errors: _formState.errors,
        name: name
      });

      _formState = _objectSpread(_objectSpread({}, _formState), updatedFormState);

      _subjects.state.next(updatedFormState);
    }

    _updateIsValidating(false);
  };

  var _executeSchema = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation)));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function _executeSchema(_x9) {
      return _ref11.apply(this, arguments);
    };
  }();

  var executeSchemaAndUpdateState = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(names) {
      var _yield$_executeSchema, errors, _iterator6, _step6, _name3, _error;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _executeSchema();

            case 2:
              _yield$_executeSchema = _context6.sent;
              errors = _yield$_executeSchema.errors;

              if (names) {
                _iterator6 = _createForOfIteratorHelper(names);

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    _name3 = _step6.value;
                    _error = _get(errors, _name3);
                    _error ? set(_formState.errors, _name3, _error) : unset(_formState.errors, _name3);
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
              } else {
                _formState.errors = errors;
              }

              return _context6.abrupt("return", errors);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function executeSchemaAndUpdateState(_x10) {
      return _ref12.apply(this, arguments);
    };
  }();

  var executeBuiltInValidation = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(fields, shouldOnlyCheckValid) {
      var context,
          _name4,
          field,
          _f,
          fieldValue,
          isFieldArrayRoot,
          fieldError,
          _args7 = arguments;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              context = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {
                valid: true
              };
              _context7.t0 = _regeneratorRuntime.keys(fields);

            case 2:
              if ((_context7.t1 = _context7.t0()).done) {
                _context7.next = 23;
                break;
              }

              _name4 = _context7.t1.value;
              field = fields[_name4];

              if (!field) {
                _context7.next = 21;
                break;
              }

              _f = field._f, fieldValue = _objectWithoutProperties(field, _excluded5);

              if (!_f) {
                _context7.next = 17;
                break;
              }

              isFieldArrayRoot = _names.array.has(_f.name);
              _context7.next = 11;
              return validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);

            case 11:
              fieldError = _context7.sent;

              if (!fieldError[_f.name]) {
                _context7.next = 16;
                break;
              }

              context.valid = false;

              if (!shouldOnlyCheckValid) {
                _context7.next = 16;
                break;
              }

              return _context7.abrupt("break", 23);

            case 16:
              !shouldOnlyCheckValid && (_get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));

            case 17:
              _context7.t2 = fieldValue;

              if (!_context7.t2) {
                _context7.next = 21;
                break;
              }

              _context7.next = 21;
              return executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);

            case 21:
              _context7.next = 2;
              break;

            case 23:
              return _context7.abrupt("return", context.valid);

            case 24:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function executeBuiltInValidation(_x11, _x12) {
      return _ref13.apply(this, arguments);
    };
  }();

  var _removeUnmounted = function _removeUnmounted() {
    var _iterator7 = _createForOfIteratorHelper(_names.unMount),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _name5 = _step7.value;

        var field = _get(_fields, _name5);

        field && (field._f.refs ? field._f.refs.every(function (ref) {
          return !live(ref);
        }) : !live(field._f.ref)) && unregister(_name5);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    _names.unMount = new Set();
  };

  var _getDirty = function _getDirty(name, data) {
    return name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues);
  };

  var _getWatch = function _getWatch(names, defaultValue, isGlobal) {
    return generateWatchOutput(names, _names, _objectSpread({}, _state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? _defineProperty({}, names, defaultValue) : defaultValue), isGlobal, defaultValue);
  };

  var _getFieldArray = function _getFieldArray(name) {
    return compact(_get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? _get(_defaultValues, name, []) : []));
  };

  var setFieldValue = function setFieldValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var field = _get(_fields, name);

    var fieldValue = value;

    if (field) {
      var fieldReference = field._f;

      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? '' : value;

        if (isMultipleSelect(fieldReference.ref)) {
          _toConsumableArray(fieldReference.ref.options).forEach(function (optionRef) {
            return optionRef.selected = fieldValue.includes(optionRef.value);
          });
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach(function (checkboxRef) {
              return (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find(function (data) {
                return data === checkboxRef.value;
              }) : fieldValue === checkboxRef.value);
            }) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach(function (radioRef) {
              return radioRef.checked = radioRef.value === fieldValue;
            });
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = '';
        } else {
          fieldReference.ref.value = fieldValue;

          if (!fieldReference.ref.type) {
            _subjects.values.next({
              name: name,
              values: _objectSpread({}, _formValues)
            });
          }
        }
      }
    }

    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };

  var setValues = function setValues(name, value, options) {
    for (var fieldKey in value) {
      var fieldValue = value[fieldKey];
      var fieldName = "".concat(name, ".").concat(fieldKey);

      var field = _get(_fields, fieldName);

      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };

  var setValue = function setValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var field = _get(_fields, name);

    var isFieldArray = _names.array.has(name);

    var cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);

    if (isFieldArray) {
      _subjects.array.next({
        name: name,
        values: _objectSpread({}, _formValues)
      });

      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name: name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }

    isWatched(name, _names) && _subjects.state.next(_objectSpread({}, _formState));

    _subjects.values.next({
      name: name,
      values: _objectSpread({}, _formValues)
    });

    !_state.mount && flushRootRender();
  };

  var onChange = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(event) {
      var target, name, isFieldValueUpdated, field, getCurrentFieldValue, _error2, isValid, fieldValue, isBlurEvent, shouldSkipValidation, watched, fieldState, shouldRender, _yield$_executeSchema2, errors, previousErrorLookupResult, errorLookupResult;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              target = event.target;
              name = target.name;
              isFieldValueUpdated = true;
              field = _get(_fields, name);

              getCurrentFieldValue = function getCurrentFieldValue() {
                return target.type ? getFieldValue(field._f) : getEventValue(event);
              };

              if (!field) {
                _context8.next = 47;
                break;
              }

              fieldValue = getCurrentFieldValue();
              isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
              shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !_get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, _get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
              watched = isWatched(name, _names, isBlurEvent);
              set(_formValues, name, fieldValue);

              if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
              } else if (field._f.onChange) {
                field._f.onChange(event);
              }

              fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
              shouldRender = !isEmptyObject(fieldState) || watched;
              !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: _objectSpread({}, _formValues)
              });

              if (!shouldSkipValidation) {
                _context8.next = 18;
                break;
              }

              _proxyFormState.isValid && _updateValid();
              return _context8.abrupt("return", shouldRender && _subjects.state.next(_objectSpread({
                name: name
              }, watched ? {} : fieldState)));

            case 18:
              !isBlurEvent && watched && _subjects.state.next(_objectSpread({}, _formState));

              _updateIsValidating(true);

              if (!_options.resolver) {
                _context8.next = 32;
                break;
              }

              _context8.next = 23;
              return _executeSchema([name]);

            case 23:
              _yield$_executeSchema2 = _context8.sent;
              errors = _yield$_executeSchema2.errors;
              previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
              errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
              _error2 = errorLookupResult.error;
              name = errorLookupResult.name;
              isValid = isEmptyObject(errors);
              _context8.next = 46;
              break;

            case 32:
              _context8.next = 34;
              return validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);

            case 34:
              _context8.t0 = name;
              _error2 = _context8.sent[_context8.t0];
              isFieldValueUpdated = isNaN(fieldValue) || fieldValue === _get(_formValues, name, fieldValue);

              if (!isFieldValueUpdated) {
                _context8.next = 46;
                break;
              }

              if (!_error2) {
                _context8.next = 42;
                break;
              }

              isValid = false;
              _context8.next = 46;
              break;

            case 42:
              if (!_proxyFormState.isValid) {
                _context8.next = 46;
                break;
              }

              _context8.next = 45;
              return executeBuiltInValidation(_fields, true);

            case 45:
              isValid = _context8.sent;

            case 46:
              if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, _error2, fieldState);
              }

            case 47:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function onChange(_x13) {
      return _ref15.apply(this, arguments);
    };
  }();

  var trigger = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(name) {
      var options,
          isValid,
          validationResult,
          fieldNames,
          errors,
          _args10 = arguments;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
              fieldNames = convertToArrayPayload(name);

              _updateIsValidating(true);

              if (!_options.resolver) {
                _context10.next = 11;
                break;
              }

              _context10.next = 6;
              return executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);

            case 6:
              errors = _context10.sent;
              isValid = isEmptyObject(errors);
              validationResult = name ? !fieldNames.some(function (name) {
                return _get(errors, name);
              }) : isValid;
              _context10.next = 21;
              break;

            case 11:
              if (!name) {
                _context10.next = 18;
                break;
              }

              _context10.next = 14;
              return Promise.all(fieldNames.map( /*#__PURE__*/function () {
                var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(fieldName) {
                  var field;
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          field = _get(_fields, fieldName);
                          _context9.next = 3;
                          return executeBuiltInValidation(field && field._f ? _defineProperty({}, fieldName, field) : field);

                        case 3:
                          return _context9.abrupt("return", _context9.sent);

                        case 4:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function (_x15) {
                  return _ref17.apply(this, arguments);
                };
              }()));

            case 14:
              validationResult = _context10.sent.every(Boolean);
              !(!validationResult && !_formState.isValid) && _updateValid();
              _context10.next = 21;
              break;

            case 18:
              _context10.next = 20;
              return executeBuiltInValidation(_fields);

            case 20:
              validationResult = isValid = _context10.sent;

            case 21:
              _subjects.state.next(_objectSpread(_objectSpread(_objectSpread({}, !isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
              }), _options.resolver || !name ? {
                isValid: isValid
              } : {}), {}, {
                errors: _formState.errors,
                isValidating: false
              }));

              options.shouldFocus && !validationResult && focusFieldBy(_fields, function (key) {
                return key && _get(_formState.errors, key);
              }, name ? fieldNames : _names.mount);
              return _context10.abrupt("return", validationResult);

            case 24:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function trigger(_x14) {
      return _ref16.apply(this, arguments);
    };
  }();

  var getValues = function getValues(fieldNames) {
    var values = _objectSpread(_objectSpread({}, _defaultValues), _state.mount ? _formValues : {});

    return isUndefined(fieldNames) ? values : isString(fieldNames) ? _get(values, fieldNames) : fieldNames.map(function (name) {
      return _get(values, name);
    });
  };

  var getFieldState = function getFieldState(name, formState) {
    return {
      invalid: !!_get((formState || _formState).errors, name),
      isDirty: !!_get((formState || _formState).dirtyFields, name),
      isTouched: !!_get((formState || _formState).touchedFields, name),
      error: _get((formState || _formState).errors, name)
    };
  };

  var clearErrors = function clearErrors(name) {
    name && convertToArrayPayload(name).forEach(function (inputName) {
      return unset(_formState.errors, inputName);
    });

    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };

  var setError = function setError(name, error, options) {
    var ref = (_get(_fields, name, {
      _f: {}
    })._f || {}).ref;
    set(_formState.errors, name, _objectSpread(_objectSpread({}, error), {}, {
      ref: ref
    }));

    _subjects.state.next({
      name: name,
      errors: _formState.errors,
      isValid: false
    });

    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };

  var watch = function watch(name, defaultValue) {
    return isFunction(name) ? _subjects.values.subscribe({
      next: function next(payload) {
        return name(_getWatch(undefined, defaultValue), payload);
      }
    }) : _getWatch(name, defaultValue, true);
  };

  var unregister = function unregister(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _iterator8 = _createForOfIteratorHelper(name ? convertToArrayPayload(name) : _names.mount),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var fieldName = _step8.value;

        _names.mount.delete(fieldName);

        _names.array.delete(fieldName);

        if (!options.keepValue) {
          unset(_fields, fieldName);
          unset(_formValues, fieldName);
        }

        !options.keepError && unset(_formState.errors, fieldName);
        !options.keepDirty && unset(_formState.dirtyFields, fieldName);
        !options.keepTouched && unset(_formState.touchedFields, fieldName);
        !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    _subjects.values.next({
      values: _objectSpread({}, _formValues)
    });

    _subjects.state.next(_objectSpread(_objectSpread({}, _formState), !options.keepDirty ? {} : {
      isDirty: _getDirty()
    }));

    !options.keepIsValid && _updateValid();
  };

  var register = function register(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var field = _get(_fields, name);

    var disabledIsDefined = isBoolean(options.disabled);
    set(_fields, name, _objectSpread(_objectSpread({}, field || {}), {}, {
      _f: _objectSpread(_objectSpread({}, field && field._f ? field._f : {
        ref: {
          name: name
        }
      }), {}, {
        name: name,
        mount: true
      }, options)
    }));

    _names.mount.add(name);

    field ? disabledIsDefined && set(_formValues, name, options.disabled ? undefined : _get(_formValues, name, getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
    return _objectSpread(_objectSpread(_objectSpread({}, disabledIsDefined ? {
      disabled: options.disabled
    } : {}), _options.progressive ? {
      required: !!options.required,
      min: getRuleValue(options.min),
      max: getRuleValue(options.max),
      minLength: getRuleValue(options.minLength),
      maxLength: getRuleValue(options.maxLength),
      pattern: getRuleValue(options.pattern)
    } : {}), {}, {
      name: name,
      onChange: onChange,
      onBlur: onChange,
      ref: function (_ref19) {
        function ref(_x16) {
          return _ref19.apply(this, arguments);
        }

        ref.toString = function () {
          return _ref19.toString();
        };

        return ref;
      }(function (ref) {
        if (ref) {
          register(name, options);
          field = _get(_fields, name);
          var fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
          var radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          var refs = field._f.refs || [];

          if (radioOrCheckbox ? refs.find(function (option) {
            return option === fieldRef;
          }) : fieldRef === field._f.ref) {
            return;
          }

          set(_fields, name, {
            _f: _objectSpread(_objectSpread({}, field._f), radioOrCheckbox ? {
              refs: [].concat(_toConsumableArray(refs.filter(live)), [fieldRef], _toConsumableArray(Array.isArray(_get(_defaultValues, name)) ? [{}] : [])),
              ref: {
                type: fieldRef.type,
                name: name
              }
            } : {
              ref: fieldRef
            })
          });
          updateValidAndValue(name, false, undefined, fieldRef);
        } else {
          field = _get(_fields, name, {});

          if (field._f) {
            field._f.mount = false;
          }

          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      })
    });
  };

  var _focusError = function _focusError() {
    return _options.shouldFocusError && focusFieldBy(_fields, function (key) {
      return key && _get(_formState.errors, key);
    }, _names.mount);
  };

  var handleSubmit = function handleSubmit(onValid, onInvalid) {
    return /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
        var fieldValues, _yield$_executeSchema3, errors, values;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (e) {
                  e.preventDefault && e.preventDefault();
                  e.persist && e.persist();
                }

                fieldValues = cloneObject(_formValues);

                _subjects.state.next({
                  isSubmitting: true
                });

                if (!_options.resolver) {
                  _context11.next = 13;
                  break;
                }

                _context11.next = 6;
                return _executeSchema();

              case 6:
                _yield$_executeSchema3 = _context11.sent;
                errors = _yield$_executeSchema3.errors;
                values = _yield$_executeSchema3.values;
                _formState.errors = errors;
                fieldValues = values;
                _context11.next = 15;
                break;

              case 13:
                _context11.next = 15;
                return executeBuiltInValidation(_fields);

              case 15:
                unset(_formState.errors, 'root');

                if (!isEmptyObject(_formState.errors)) {
                  _context11.next = 22;
                  break;
                }

                _subjects.state.next({
                  errors: {}
                });

                _context11.next = 20;
                return onValid(fieldValues, e);

              case 20:
                _context11.next = 27;
                break;

              case 22:
                if (!onInvalid) {
                  _context11.next = 25;
                  break;
                }

                _context11.next = 25;
                return onInvalid(_objectSpread({}, _formState.errors), e);

              case 25:
                _focusError();

                setTimeout(_focusError);

              case 27:
                _subjects.state.next({
                  isSubmitted: true,
                  isSubmitting: false,
                  isSubmitSuccessful: isEmptyObject(_formState.errors),
                  submitCount: _formState.submitCount + 1,
                  errors: _formState.errors
                });

              case 28:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x17) {
        return _ref20.apply(this, arguments);
      };
    }();
  };

  var resetField = function resetField(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, _get(_defaultValues, name));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, options.defaultValue);
      }

      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }

      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, _get(_defaultValues, name)) : _getDirty();
      }

      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }

      _subjects.state.next(_objectSpread({}, _formState));
    }
  };

  var _reset = function _reset(formValues) {
    var keepStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var updatedValues = formValues || _defaultValues;
    var cloneUpdatedValues = cloneObject(updatedValues);
    var values = formValues && !isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;

    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }

    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
        var _iterator9 = _createForOfIteratorHelper(_names.mount),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var fieldName = _step9.value;
            _get(_formState.dirtyFields, fieldName) ? set(values, fieldName, _get(_formValues, fieldName)) : setValue(fieldName, _get(values, fieldName));
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          var _iterator10 = _createForOfIteratorHelper(_names.mount),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _name6 = _step10.value;

              var _field = _get(_fields, _name6);

              if (_field && _field._f) {
                var fieldReference = Array.isArray(_field._f.refs) ? _field._f.refs[0] : _field._f.ref;

                if (isHTMLElement(fieldReference)) {
                  var form = fieldReference.closest('form');

                  if (form) {
                    form.reset();
                    break;
                  }
                }
              }
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        }

        _fields = {};
      }

      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);

      _subjects.array.next({
        values: _objectSpread({}, values)
      });

      _subjects.values.next({
        values: _objectSpread({}, values)
      });
    }

    _names = {
      mount: new Set(),
      unMount: new Set(),
      array: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ''
    };
    !_state.mount && flushRootRender();
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
    _state.watch = !!props.shouldUnregister;

    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };

  var reset = function reset(formValues, keepStateOptions) {
    return _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  };

  var setFocus = function setFocus(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var field = _get(_fields, name);

    var fieldReference = field && field._f;

    if (fieldReference) {
      var fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;

      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    }
  };

  var _updateFormState = function _updateFormState(updatedFormState) {
    _formState = _objectSpread(_objectSpread({}, _formState), updatedFormState);
  };

  var _resetDefaultValues = function _resetDefaultValues() {
    return isFunction(_options.defaultValues) && _options.defaultValues().then(function (values) {
      reset(values, _options.resetOptions);

      _subjects.state.next({
        isLoading: false
      });
    });
  };

  return {
    control: {
      register: register,
      unregister: unregister,
      getFieldState: getFieldState,
      handleSubmit: handleSubmit,
      setError: setError,
      _executeSchema: _executeSchema,
      _getWatch: _getWatch,
      _getDirty: _getDirty,
      _updateValid: _updateValid,
      _removeUnmounted: _removeUnmounted,
      _updateFieldArray: _updateFieldArray,
      _getFieldArray: _getFieldArray,
      _reset: _reset,
      _resetDefaultValues: _resetDefaultValues,
      _updateFormState: _updateFormState,
      _subjects: _subjects,
      _proxyFormState: _proxyFormState,

      get _fields() {
        return _fields;
      },

      get _formValues() {
        return _formValues;
      },

      get _state() {
        return _state;
      },

      set _state(value) {
        _state = value;
      },

      get _defaultValues() {
        return _defaultValues;
      },

      get _names() {
        return _names;
      },

      set _names(value) {
        _names = value;
      },

      get _formState() {
        return _formState;
      },

      set _formState(value) {
        _formState = value;
      },

      get _options() {
        return _options;
      },

      set _options(value) {
        _options = _objectSpread(_objectSpread({}, _options), value);
      }

    },
    trigger: trigger,
    register: register,
    handleSubmit: handleSubmit,
    watch: watch,
    setValue: setValue,
    getValues: getValues,
    reset: reset,
    resetField: resetField,
    clearErrors: clearErrors,
    unregister: unregister,
    setError: setError,
    setFocus: setFocus,
    getFieldState: getFieldState
  };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */


function useForm() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _formControl = React.useRef();

  var _React$useState9 = React.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
  }),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      formState = _React$useState10[0],
      updateFormState = _React$useState10[1];

  if (!_formControl.current) {
    _formControl.current = _objectSpread(_objectSpread({}, createFormControl(props, function () {
      return updateFormState(function (formState) {
        return _objectSpread({}, formState);
      });
    })), {}, {
      formState: formState
    });
  }

  var control = _formControl.current.control;
  control._options = props;
  useSubscribe({
    subject: control._subjects.state,
    next: function next(value) {
      if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
        updateFormState(_objectSpread({}, control._formState));
      }
    }
  });
  React.useEffect(function () {
    if (props.values && !deepEqual(props.values, control._defaultValues)) {
      control._reset(props.values, control._options.resetOptions);
    } else {
      control._resetDefaultValues();
    }
  }, [props.values, control]);
  React.useEffect(function () {
    if (!control._state.mount) {
      control._updateValid();

      control._state.mount = true;
    }

    if (control._state.watch) {
      control._state.watch = false;

      control._subjects.state.next(_objectSpread({}, control._formState));
    }

    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}

export { Controller, Form, FormProvider, appendErrors, _get as get, set, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch };